"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.geolocalisation = exports.postCities = exports.postSubdivisions = exports.postCountries = void 0;
const createApi_1 = require("../../helpers/createApi");
// We do not support ja
const supportedGeolocLocales = ['de', 'en', 'es', 'fr'];
const getSupportedLocale = (locale) => (supportedGeolocLocales.includes(locale) ? locale : 'en');
const transformOptions = ({ locale, ...options }) => ({
    locale: getSupportedLocale(locale),
    ...options,
});
const postCountries = (caller) => (options) => caller(`/geoip/countries`).post(transformOptions(options));
exports.postCountries = postCountries;
const postSubdivisions = (caller) => (options) => caller(`/geoip/subdivisions`).post(transformOptions(options));
exports.postSubdivisions = postSubdivisions;
const postCities = (caller) => (options) => caller(`/geoip/cities`).post(transformOptions(options));
exports.postCities = postCities;
exports.geolocalisation = (0, createApi_1.createAPIFactory)({
    postCountries: exports.postCountries,
    postSubdivisions: exports.postSubdivisions,
    postCities: exports.postCities,
});
//# sourceMappingURL=api.js.map